import React from "react";
import { Box } from "@origin-digital/ods-core";
import { ProjectsTable } from "src/components/Projects";

export const ContentSection = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      data-id="contentSection.root"
    >
      <ProjectsTable />
    </Box>
  );
};
